import { createSlice } from "@reduxjs/toolkit";

export const layerOptionsSlice = createSlice({
    name: "layerOptions",
    initialState: { layerId: undefined, layerName: undefined },
    reducers: {
        // sets data for changing opacity of layer
        setActiveLayer: (state, action) => {
            state.layerId = action.payload.layerId;
            state.layerName = action.payload.layerName;
        },
    },
});

export const { setActiveLayer } = layerOptionsSlice.actions;
export default layerOptionsSlice.reducer;
